import { combineReducers } from 'redux';

import byInterventionId from './byInterventionId';
import data from './data';

/**
 * @typedef {{
 *  data: import('utils/ReduxUtils').EntitySlice<import('modules/interventions/types/projections/detailed-intervention-event').DetailedInterventionEvent>,
 *  byInterventionId: Record<string, string[]>
 * }} InterventionEventSlice
 * */

export default combineReducers({
  data,
  byInterventionId,
});
